// Display unit for PM5 force (curves are stored in N). kg = lbs × 0.4536.
const KEY = 'force_unit';
export const FORCE_UNITS = ['kg', 'lbs'];
const N_PER = { kg: 4.44822 / 0.4536, lbs: 4.44822 };

export function getForceUnit() {
  try { return localStorage.getItem(KEY) === 'lbs' ? 'lbs' : 'kg'; } catch { return 'kg'; }
}

export function setForceUnit(u) {
  try { localStorage.setItem(KEY, u); } catch { /* storage unavailable */ }
  window.dispatchEvent(new CustomEvent('crewz-force-unit-changed', { detail: u }));
}

export const fromNewtons = (n, unit) => n / N_PER[unit];
